
export default () => ({
  currencies: {
    RUB: {
      USD: null,
      EUR: null
    }
  },
  hasErrors: false
})
